import React from 'react'
import Logo from '../logo/Logo.js';
import {LoginBtn} from '../login-logout-btn/LoginBtn.js';
import { Outlet } from 'react-router';
import './ticketPage.css'
import { Container } from '@mui/material';

export default function TicketPage() {
  return (
    <div className='ticket-outlet'>
        <div className='tkt-flex'>
            <Container><Logo /></Container>
            <LoginBtn />
        </div>
        <Outlet />
    </div>
  )
}
